import { ssrApi } from 'api/ssr';
import { QuestionPage } from 'components/template/question';
import { IQuestion } from 'constants/types';
import { ParsedUrlQuery } from 'querystring';
import { isValidEntity, notFoundResult } from 'utils/ssr-not-found';

export default function Question({
  mainQuestion,
  childrenQuestions,
}: {
  mainQuestion: IQuestion;
  childrenQuestions: IQuestion[];
}) {
  return (
    <QuestionPage
      mainQuestion={mainQuestion}
      childrenQuestions={childrenQuestions}
    />
  );
}

export async function getServerSideProps({ query }: { query: ParsedUrlQuery }) {
  const { id } = query;

  const main = await ssrApi.questions.getById(id?.toString());

  const { results: childrenQuestions } = await ssrApi.questions.getByParentId(
    id?.toString()
  );

  if (!isValidEntity(main)) {
    return notFoundResult();
  }

  return {
    props: {
      mainQuestion: main,
      childrenQuestions: childrenQuestions?.length ? childrenQuestions : [],
    },
  };
}
